export default "__VITE_ASSET__7aCmdzfA__"